import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import NotificatiopnPreference from './notificationPreference/index';
import OrganizationDetails from './organizationDetails/index';
import ProfileDetails from './userDetails/index';
import { useHook as CustomerHook } from './useHook';
import { useSelector } from 'react-redux';

const ProfileManagement = () => {
  const { fetchCustomerInfo } = CustomerHook();
  const { customerInformation } = useSelector(
    (state: any) => state.profileManagement,
  );
  const location = useLocation();
  const pathname = location.pathname;
  const navigate = useNavigate();
  const [activeProfileManagementPage, setActiveProfileManagementPage] =
    useState('');

  // const getCustomerDetails = async () => {
  //   await fetchCustomerInfo();
  // };
  // useEffect(() => {
  //   if (Object.keys(customerInformation)?.length == 0) {
  //     getCustomerDetails();
  //   }
  // }, []);

  useEffect(() => {
    if (pathname === '/profilemanagement/personaldetails') {
      setActiveProfileManagementPage('personaldetails');
    } else if (pathname === '/profilemanagement/organizationdetails') {
      setActiveProfileManagementPage('organizationdetails');
    } else {
      setActiveProfileManagementPage('notificationpreference');
    }
    //   pathname === '/profilemanagement/personaldetails'
    //     ? setActiveProfileManagementPage(true)
    //     : setActiveProfileManagementPage(false);
  }, [pathname]);

  const handlePageChange = (page: string) => {
    if (pathname !== page) {
      navigate(page);
    }
  };
  return (
    <>
      <div className="audilog_update profilemanagement_toggle">
        <Button
          className={
            activeProfileManagementPage === 'personaldetails'
              ? 'activeEdit'
              : ''
          }
          onClick={() => handlePageChange('/profilemanagement/personaldetails')}
        >
          Personal details
        </Button>
        <Button
          className={
            activeProfileManagementPage === 'organizationdetails'
              ? 'activeEdit'
              : ''
          }
          onClick={() =>
            handlePageChange('/profilemanagement/organizationdetails')
          }
        >
          Organization Details
        </Button>
        <Button
          className={
            activeProfileManagementPage === 'notificationpreference'
              ? 'activeEdit'
              : ''
          }
          onClick={() =>
            handlePageChange('/profilemanagement/notificationpreference')
          }
        >
          Notification preference
        </Button>
      </div>

      {activeProfileManagementPage === 'personaldetails' ? (
        <ProfileDetails />
      ) : activeProfileManagementPage === 'organizationdetails' ? (
        <OrganizationDetails />
      ) : (
        <NotificatiopnPreference />
      )}
    </>
  );
};

export default ProfileManagement;
